<template lang="pug">
  .select-box.select-box--date-range(:class="classObject")
    button.select-box__content(
      :class="{'selected': isSelected}"
      type="button"
      @click.self.stop="onClick"
    )
      .select-box__custom-title(:class="{'select-box__custom-title--visible': isDateRangeValid}") {{title}}
      date-range-picker.select-box__title(
        ref="picker"
        opens="right"
        :locale-data="localeData"
        :minDate="new Date()"
        :timePicker="false"
        :timePicker24Hour="false"
        :showWeekNumbers="false"
        :showDropdowns="false"
        :ranges="false"
        :autoApply="true"
        v-model="dates"
        @toggle="onToggle"
      )
        template(v-slot:input="{startDate, endDate}")
          template(v-if="startDate || endDate")
            | {{ dateToText(startDate) }} - {{ dateToText(endDate) }}
          template(v-else) {{title}}
      .select-box__placeholder(v-show="!isDateRangeValid")
        span.select-box__placeholder-text {{placeholder}}
        v-icon.select-box__placeholder-icon(name="chevron-right")

    .select-box__chevron-icon(v-show="!isDateRangeValid")
      v-icon.select-box__clear-icon(name="chevron-right")
    button.select-box__clear(v-show="isDateRangeValid" @click="$emit('clear')")
      v-icon.select-box__clear-icon(name="x")
</template>

<script>
import avatarChecker from '@/mixins/avatar-checker'
import imageOnload from '../mixins/image-onload'
import SelectBox from "@/components/SelectBox";
import {mapGetters, mapActions} from "vuex";

import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import {timestampToText} from "@/store/helpers/event-timestamp";

export default {
  components: {DateRangePicker},
  mixins: [avatarChecker, imageOnload],
  extends: {SelectBox},
  props: {
    title: {type: String},
    placeholder: {type: String},
    route: {type: String},
    disabled: {type: Boolean},
    isAccordion: {type: Boolean},
  },
  data() {
    return {
      isPaneCollapsed: false,
      localeData: {
        direction: 'ltr',
        format: 'MM.dd.yyyy',
        separator: ' - ',
        applyLabel: 'Выбрать',
        cancelLabel: 'Отмена',
        weekLabel: 'Неделя',
        customRangeLabel: 'Custom Range',
        daysOfWeek: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
        monthNames: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
        firstDay: 1
      },
    }
  },
  computed: {
    ...mapGetters('date', {
      dateRange: 'getDateRange',
      isDateRangeValid: 'isValid',
    }),
    dates: {
      get() {
        return this.dateRange;
      },
      set({startDate, endDate}) {
        this.setDate({startDate, endDate});
      }
    },
    classObject() {
      return {
        'disabled': this.disabled,
      }
    },
    isSelected() {
      return this.isDateRangeValid;
    }
  },
  watch: {
    isDateRangeValid(isValid) {
      if (!isValid) {
        this.clearDate();
      }
    },
  },
  methods: {
    ...mapActions('date', ['setDate', 'clearDate']),
    onClick() {
      this.$refs.picker.togglePicker(true);
    },
    onToggle(isOpen) {
      if (!isOpen && !this.isDateRangeValid) {
        this.clearDate();
      }
    },
    dateToText(date) {
      if (date) {
        return timestampToText(+new Date(date) / 1000, true);
      }
    },
  },
};
</script>
